<button mat-icon-button class="close-button" [mat-dialog-close]="true">
  <mat-icon class="close-icon" color="warn">close</mat-icon>
</button>
<div class="dialog-content-wrapper invoiceDialog" id="invoice-wrapper">
  <mat-toolbar class="header m-0 fx-row">
    <mat-toolbar-row class="fx-row fx-main-between fx-cross-center fx-flex">
      <span class="title dialog-title fx-flex" translate="invoice_"></span>
    </mat-toolbar-row>
  </mat-toolbar>
  <div mat-dialog-content id="invoice-content" class="fx-col">
    <div class="fx-row fx-flex-100-in-col">
      <div class="fx-flex-40">
        <div class="fx-col">
          <div>
            <p class="colorf-s-14">
              <span [textContent]="config.localSettings.Company.Address.Street"></span>&nbsp;
              <br />
              <span [textContent]="config.localSettings.Company.Address.City"></span>&nbsp;
              <span [textContent]="config.localSettings.Company.Address.State"></span>&nbsp;
              <span [textContent]="config.localSettings.Company.Address.Zip"></span>&nbsp;
              <br />
              <span [textContent]="config.localSettings.Company.Address.Country"></span>
              <br />
              <span [textContent]="config.localSettings.Company.Address.Phone"></span>
            </p>
          </div>
        </div>
      </div>
      <div class="fx-flex-20">

      </div>
      <div class="fx-row fx-main-end fx-cross-start fx-flex-40">
        <div class="fx-col fx-main-end fx-cross-stretch">
          <div class="invoice">
            <h3 translate="invoice_"></h3>
          </div>
          <div>
            <label class="colorf-s-14" translate="Order Date"></label> <span class="colorf-s-14"
          [textContent]="OrderData.OrderDate  | date :'MM/dd/yyyy'"></span>
        </div>
        <div>
          <label class="colorf-s-14" translate="invoice_"></label> <span class="colorf-s-14"
        [textContent]="OrderData.OrderNumber"></span>
      </div>
    </div>
  </div>

</div>
<div class="horizontalLine">
</div>
<div class="p-t-10 m-b-30 fx-row xs-fx-col gt-xs-fx-main-around gt-xs-fx-cross-center">
  <div class="p-r-b">
    @if (OrderData?.Packages && OrderData?.Packages?.length>0) {
      <div class="fx-row">
        <div class="p-r-15">
          <label class="colorf-s-14" translate="invoice_ship_to"></label>&nbsp;
        </div>
        <div>
          <span class="colorf-s-14" [textContent]="OrderData?.Packages[0].ShipTo"></span><br>
          <span class="colorf-s-14" [textContent]="OrderData?.Packages[0].Address1"></span>&nbsp;<span
        class="colorf-s-14" [textContent]="OrderData?.Packages[0].Address2"></span><br>
        <span class="colorf-s-14" [textContent]="OrderData?.Packages[0].City"></span>&nbsp;<span
      class="colorf-s-14" [textContent]="OrderData.State"></span>&nbsp;<span class="colorf-s-14"
    [textContent]="OrderData?.Packages[0].Zip"></span>,&nbsp;<span class="colorf-s-14"
  [textContent]="OrderData.Packages[0].CountryCode"></span>
</div>
</div>
}
</div>
<div>
</div>
</div>
<div class="table1 m-b-30">
  <table>
    <thead>
      <tr>
        <th translate="invoice_customer"></th>
        <th translate="Source"></th>
        <th translate="invoice_status"></th>
        <th translate="ship_via"></th>
        <th translate="shipping_date"></th>
        <th translate="tracking"></th>
      </tr>
    </thead>
    <tbody>
      <tr>
        <td [textContent]="OrderData.DistributorID"></td>
        <td [textContent]="OrderData.OrderTypeDescription"></td>
        <td [textContent]="OrderData.IsShipped"></td>
        <td [textContent]="OrderData.Packages?.length>0?OrderData.Packages[0].Carrier:'--'"> </td>
        <td [textContent]="OrderData.Packages?.length>0?OrderData.Packages[0].ShippedDate :'--'"></td>
        <td [textContent]="OrderData.Packages?.length>0?OrderData.Packages[0].TrackingNumber:'--'"></td>
      </tr>
    </tbody>
  </table>
</div>
<div class="table2 m-b-30">
  <table>
    <thead>
      <tr>
        <th translate="SKU"></th>
        <th translate="global_description"></th>
        <th translate="global_quantity"></th>
        <th translate="unit_price"></th>
        <th translate="global_pv"></th>
        <th translate="invoice_unit_cv"></th>
        <th translate="invoice_line_total"></th>
      </tr>
    </thead>
    <tbody>
      @for (items of OrderData.LineItems; track items) {
        <tr>
          <td [textContent]="items.SKU"></td>
          <td [textContent]="items.ProductName"></td>
          <td [textContent]="items.Qty"></td>
          <td [textContent]="items.Amount | currency:companyService.selectedCurrency.CurrencyCode"> </td>
          <td [textContent]="items.CV"> </td>
          <td [textContent]="items.QV"> </td>
          <td
            [textContent]="(items.Amount* items.Qty)| currency:companyService.selectedCurrency.CurrencyCode">
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
<div class="fx-row xs-fx-col fx-flex-100-in-col">
  <div class="m-t-20 fx-col xs-fx-flex-67-in-col sm-fx-flex-62 print-fx-flex-67 gt-sm-fx-flex-67 xs-fx-hide">
    <div>
      <label class="colorf-s-14" translate="invoice_notes"></label>
    </div>
    <div class="noteBox">

    </div>
  </div>
  <div class="xs-fx-flex-5-in-col print-fx-flex-5 gt-xs-fx-flex-5 xs-fx-hide"></div>
  <div class="table3 xs-fx-flex-100-in-col sm-fx-flex-33 print-fx-flex-28 gt-sm-fx-flex-28">
    <table style="border-spacing: 0px; max-width: 100%;">
      <tr>
        <td translate="subTotal"></td>
        <td class="table3td"
          [textContent]="$safeNavigationMigration(OrderData?.Totals[0]?.SubTotal)| currency:companyService.selectedCurrency.CurrencyCode">
        </td>
      </tr>
      <tr>
        <td translate="shippinghandling"></td>
        <td class="table3td"
          [textContent]="$safeNavigationMigration(OrderData?.Totals[0]?.Shipping)| currency:companyService.selectedCurrency.CurrencyCode">
        </td>
      </tr>
      <tr>
        <td translate="tax"></td>
        <td class="table3td"
          [textContent]="$safeNavigationMigration(OrderData?.Totals[0]?.Tax)| currency:companyService.selectedCurrency.CurrencyCode">
        </td>
      </tr>
      <tr>
        <td translate="grand_total"></td>
        <td class="table3td"
          [textContent]="($safeNavigationMigration(OrderData?.Totals[0]?.SubTotal) + $safeNavigationMigration(OrderData?.Totals[0]?.Shipping) +$safeNavigationMigration(OrderData?.Totals[0]?.Tax))| currency:companyService.selectedCurrency.CurrencyCode">
        </td>
      </tr>
      <tr>
        <td translate="discount"></td>
        <td class="table3td"
          [textContent]="$safeNavigationMigration(OrderData?.Totals[0]?.DiscountTotal)| currency:companyService.selectedCurrency.CurrencyCode">
        </td>
      </tr>
      <tr>
        <td translate="total_paid"></td>
        <td class="table3td"
          [textContent]="$safeNavigationMigration(OrderData.Totals[0]?.Total)| currency:companyService.selectedCurrency.CurrencyCode">
        </td>
      </tr>
      <tr>
        <td translate="total_due"></td>
        <td class="table3tdLast"
          [textContent]="$safeNavigationMigration(OrderData.Totals[0]?.TotalDues)| currency:companyService.selectedCurrency.CurrencyCode">
        </td>
      </tr>
    </table>
  </div>
  <div class="m-t-20 fx-col xs-fx-flex-100-in-col sm-fx-flex-62 print-fx-flex-67 gt-sm-fx-flex-67 gt-xs-fx-hide">
    <div>
      <label class="colorf-s-14" translate="invoice_notes"></label>
    </div>
    <div class="noteBox" [textContent]="OrderData.SpecialInstructions">
    </div>
  </div>
</div>
<div class="footer fx-row fx-main-center fx-cross-center">
  <p translate="thank_you_for_your_business"></p>
</div>
</div>
<hr>
  <div class="print-icon fx-row fx-main-end fx-cross-center">
    <button mat-icon-button styleSheetFile="assets/scss/orderinvoice.css" printSectionId="invoice-content" ngxPrint>
      <mat-icon>print</mat-icon>
    </button>
  </div>
</div>